import axiosInstance from '../utils/AxiosConfig';

class StaffAchievementsService {
  /**
   * Obtiene las estadísticas, objetivos y logros del staff para un mes/año específico
   * @param {string} staffEmail - Email del staff
   * @param {number} month - Mes (1-12)
   * @param {number} year - Año
   * @returns {Promise<Object>} Datos del staff incluyendo métricas, objetivos y logros
   */
  async getStaffAchievements(staffEmail, month = null, year = null) {
    try {
      const params = new URLSearchParams();
      if (month) params.append('month', month);
      if (year) params.append('year', year);

      const queryString = params.toString();
      const url = `/staff/achievements/${staffEmail}${queryString ? `?${queryString}` : ''}`;

      const response = await axiosInstance.get(url);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching staff achievements:', error);
      throw error;
    }
  }
}

export default new StaffAchievementsService();

